import { applyClaimAdjustment } from "./claim-adjustment";
import { cumulativeWithCola } from "./cola";
import { resolvePia } from "./pia";
import type { BenefitAtAge, PersonInputs } from "./types";

/**
 * Compute a BenefitAtAge entry for a specific claim age.
 * Used to produce the four standard rows (62 / FRA / 70 / custom) per person.
 */
export function benefitAtAge(params: {
  person: PersonInputs;
  claimAge: number;
  colaRate: number;
}): BenefitAtAge {
  const { person, claimAge, colaRate } = params;
  const birthYear = new Date(person.dob).getUTCFullYear();
  const pia = resolvePia(person);

  const { monthlyBenefit, pctOfPia } = applyClaimAdjustment({
    pia,
    birthYear,
    claimAge,
  });

  const claimAgeMonths = Math.round(claimAge * 12);
  const longevityAgeMonths = Math.round(person.longevityAge * 12);

  const lifetimeCumulative = cumulativeWithCola({
    monthlyBenefitInitial: monthlyBenefit,
    claimAgeMonths,
    longevityAgeMonths,
    colaRate,
  });

  return {
    claimAge,
    monthlyBenefitInitial: monthlyBenefit,
    lifetimeCumulative,
    pctOfPia,
  };
}
